<template>
  <q-dialog
    ref="dialog"
    :maximized="$q.platform.is.mobile"
    @hide="onDialogHide"
  >
    <q-card class="q-dialog-plugin dialog-card">
      <q-card-section class="row">
        <div
          class="text-h6 ellipsis col"
        >
          {{ $t('auditLogReports.viewAuditTrail') }}
        </div>
        <q-btn
          v-close-popup
          flat
          round
          dense
          icon="close"
        />
      </q-card-section>
      <q-card-section>
        <audit-trail-table
          :initial-filters="initialFilters"
          :locked-filters="lockedFilters"
        />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import AuditTrailTable from 'components/Audit/AuditTrailTable';
import { Timestamp } from 'firebase/firestore';
import { find } from 'lodash';
import { uid } from 'quasar';
import AuditLogMixin from 'src/mixins/AuditLogMixin';
import DateRanges from 'src/mixins/DateRanges';

export default {
  name: 'ViewAuditTrailDialog',

  components: {
    AuditTrailTable,
  },

  mixins: [AuditLogMixin, DateRanges],

  props: {
    collection: {
      type: String,
      default: null,
    },
    resourceId: {
      type: String,
      default: null,
    },
  },

  emits: ['hide'],

  data() {
    return {
      initialFilters: {},
    };
  },

  computed: {

    lockedFilters() {
      return Object.keys(this.initialFilters);
    },

  },

  methods: {

    show() {
      this.initFilters();
      this.$refs.dialog.show();
    }, // show()

    hide() {
      this.$emit('hide');

      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    }, // hide()

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide');
    }, // onDialogHide()

    initFilters() {
      const initialFilters = {};
      const defaultDateRange = 'all-time';
      // // Add a default filter
      const fromDate = Timestamp
        .fromDate(find(this.periodPresets, { id: defaultDateRange }).fromTimestamp);
      const toDate = Timestamp
        .fromDate(find(this.periodPresets, { id: defaultDateRange }).toTimestamp);
      const { label } = find(this.periodPresets, { id: defaultDateRange });

      initialFilters.createTimestamp = {
        id: uid(),
        filterProperty: 'createTimestamp',
        filterPropertyType: 'Date',
        filterStatements: [
          {
            fromDate,
            toDate,
            filterDateItems: [],
            filterCriteriaType: defaultDateRange,
            customDataId: null,
            filterNegative: false,
            filteredItems: [],
            label,
          },
        ],
      };

      if (this.collection !== null) {
        initialFilters.collection = {
          id: uid(),
          filterProperty: 'collection',
          filterPropertyType: 'StringInArray',
          filterStatements: [
            {
              fromDate: null,
              toDate: null,
              filterDateItems: [],
              filterCriteriaType: null,
              customDataId: null,
              filterNegative: false,
              filteredItems: [this.collection],
              label:
                `${this.$t('auditLogReports.tableCols.collection')}: ${this.getAuditResourceType(this.collection)}`,
            },

          ],
        };
      }

      if (this.resourceId !== null) {
        initialFilters.resourceId = {
          id: uid(),
          filterProperty: 'resourceId',
          filterPropertyType: 'StringMatch',
          filterStatements: [
            {
              fromDate: null,
              toDate: null,
              filterDateItems: [],
              filterCriteriaType: 'isEqualTo',
              customDataId: null,
              filterNegative: false,
              filteredItems: this.resourceId,
              label: `${this.$t('auditLogReports.tableCols.resourceId')}: ${this.resourceId}`,
            },

          ],
        };
      }

      this.initialFilters = initialFilters;
    },

  },
};
</script>
<style lang="scss" scoped>
.dialog-card {
  width: 80vw;
  min-width: 375px;
  max-width: unset;
}

</style>
